import { request } from '@/shared/api/request'

export const downloadPdfById = (lang, id) =>
	request({
		url: `selftest/auth/pdf/${lang}?id=${id}`,
		method: 'GET',
		responseType: 'blob',
	})
